import moment from 'moment';

export function convertUTCDateToLocalDate(date: any) {
  // Check if the date is a valid Date object or a string
  let lastDate: Date;

  // If the input is a string, make sure it's parsed correctly
  if (typeof date === 'string') {
    // Try to parse ISO date strings or other common date formats
    lastDate = new Date(date);
  } else if (date instanceof Date) {
    lastDate = date;
  } else {
    // Return or throw an error if the date format is invalid
    console.error('Invalid date format:', date);
    return null;
  }

  // If the parsed date is invalid, handle it
  if (isNaN(lastDate.getTime())) {
    console.error('Invalid Date:', lastDate);
    return null;
  }

  // Convert the UTC date to local date by adjusting the timezone offset
  const newDate = new Date(
    lastDate.getTime() - lastDate.getTimezoneOffset() * 60 * 1000
  );
  return newDate;
}

// convert time to local to show it to the user 12 or 24 hour
export function convertUtcToLocal_12Or24(
  time: string,
  isTo12Hour: boolean = true
): string {
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const offsetHours = Math.floor(offset / -60);

  let [hours, minutes] = time.split(':').map(Number);
  hours += offsetHours;

  // Ensure the time is properly formatted
  const formattedTime = `${String(hours).padStart(2, '0')}:${String(
    minutes
  ).padStart(2, '0')}`;

  if (isTo12Hour) {
    return moment(formattedTime, 'HH:mm').format('hh:mm A');
  } else {
    return formattedTime;
  }
}
// convert time to utc to send it to the server
export function convertTimeToUTC(time: string): string {
  const [hours, minutes] = time.split(':').map(Number); // Extract hours and minutes
  const now = new Date(); // Get current date

  // Create a new Date object with the local time
  const localDate = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    hours,
    minutes
  );

  // Convert to UTC by getting UTC hours and minutes
  const utcHours = localDate.getUTCHours();
  const utcMinutes = localDate.getUTCMinutes();

  // Format as "HH:mm" (without using `toISOString()`)
  return `${utcHours.toString().padStart(2, '0')}:${utcMinutes
    .toString()
    .padStart(2, '0')}`;
}

// this function for the time string utc
// and we need to show to user the local time (comment time)
// export function convertUtcStringToLocal(timeString: string): string {
//   // Create a UTC Date object from the provided time string
//   const [hours, minutes] = timeString.split(':').map(Number);
//   const utcDate = new Date(Date.UTC(1970, 0, 1, hours, minutes)); // Reference date in UTC

//   // Convert to local time
//   const localHours = utcDate.getHours();
//   const localMinutes = utcDate.getMinutes();
//   const localTime = `${String(localHours).padStart(2, '0')}:${String(
//     localMinutes
//   ).padStart(2, '0')}`;

//   return localTime;
// }

// export function convertUtcStringToLocal(timeString: string): string {
//   const [hours, minutes] = timeString.split(':').map(Number);

//   // Create a Date object at UTC time
//   const utcDate = new Date(Date.UTC(1970, 0, 1, hours, minutes));

//   // Convert to local time string (24-hour format)
//   const localTime = utcDate.toLocaleTimeString(undefined, {
//     hour: '2-digit',
//     minute: '2-digit',
//     hour12: true,
//   });

//   return localTime;
// }


export function convertUtcStringToLocal(timeString: string): string {
  const [hours, minutes] = timeString.split(':').map(Number);

  // 1. Create UTC ISO string (e.g. 1970-01-01T11:32:00Z)
  const isoString = new Date(Date.UTC(1970, 0, 1, hours, minutes)).toISOString();

  // 2. Convert to local Date
  const localDate = new Date(isoString); // interpreted in local time

  // 3. Format the local time (12-hour format with AM/PM)
  return localDate.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}


// export function convertUtcStringToLocal(timeString: string): string {
//   const [hours, minutes] = timeString.split(':').map(Number);

//   // 1. Create UTC date object
//   const utcDate = new Date(Date.UTC(1970, 0, 1, hours, minutes));

//   // 2. Get user's local timezone from the environment
//   const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

//   // 3. Convert to local (zoned) time
//   const zonedDate = toZonedTime(utcDate, timeZone);

//   // 4. Format the result in local time (12-hour or 24-hour as you like)
//   const formattedTime = format(zonedDate, 'hh:mm a', { timeZone });

//   return formattedTime; // e.g., "02:32 PM"
// }

// export function convertToLocalDateTime(utcDate: string | Date): Date {
//   // Create a new Date object from the input
//   const date = new Date(utcDate);

//   // Get the UTC timestamp in milliseconds
//   const utcTimestamp = date.getTime();

//   // Get local timezone offset in milliseconds
//   const localOffset = new Date().getTimezoneOffset() * 60000;

//   // Create new date by subtracting the timezone offset
//   const localDate = new Date(utcTimestamp - localOffset);

//   return localDate;
// }


export function convertToLocalDateTime(utcDate: string | Date): Date {
  // Ensure input is treated as UTC
  const date = new Date(utcDate);

  // JavaScript Date object automatically adjusts for DST when used as local
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
    date.getUTCMilliseconds()
  );
}
